// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"b817a96b","630":"22863825","700":"22863825"}[chunkId] + ".chunk.css";
};